import { render, staticRenderFns } from "./FormProjectUserPicker.vue?vue&type=template&id=4a0296cb&"
import script from "./FormProjectUserPicker.vue?vue&type=script&lang=ts&"
export * from "./FormProjectUserPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports